export const nav = {
  home: "Bienvenido",
  howItWorks: "Cómo funciona",
  discover: "Descubrir",
  explore: "Explorar",
  exploreDesc: "Descubre miembros y destinos",
  destinations: "Destinos",
  destinationsDesc: "Explora los destinos disponibles",
  membersMap: "Mapa de miembros",
  membersMapDesc: "Encuentra miembros cerca de ti",
  pricing: "Precios",
  dashboard: "Panel de control",
  dashboardDesc: "Gestiona tus anuncios e intercambios",
  mySpace: "Mi espacio",
  myCalendar: "Mi agenda",
  myCalendarDesc: "Gestiona tu calendario e intercambios",
  incomingRequests: "Matching inteligente",
  incomingRequestsDesc: "Solicitudes recibidas y sugerencias IA",
  favorites: "Favoritos",
  favoritesDesc: "Tus destinos favoritos",
  messaging: "Mensajería",
  messagingDesc: "Conversaciones y propuestas",
  login: "Iniciar sesión",
  signup: "Registrarse",
  corporate: "Empresa",
  announcement:
    "DONKEY TRAVEL: el club europeo de intercambio de casas reservado para anfitriones de Airbnb con una calificación de 4,5 o superior",
};
